export type Testament = "OT" | "NT";

export interface Book {
  /** Canonical order, 1..66. */
  id: number;
  name: string;
  /** Lowercase, no spaces — matches the WEB source file names. */
  slug: string;
  testament: Testament;
  chapters: number;
}

// [name, chapters]; canonical Protestant order.
const OT: Array<[string, number]> = [
  ["Genesis", 50], ["Exodus", 40], ["Leviticus", 27], ["Numbers", 36], ["Deuteronomy", 34],
  ["Joshua", 24], ["Judges", 21], ["Ruth", 4], ["1 Samuel", 31], ["2 Samuel", 24],
  ["1 Kings", 22], ["2 Kings", 25], ["1 Chronicles", 29], ["2 Chronicles", 36], ["Ezra", 10],
  ["Nehemiah", 13], ["Esther", 10], ["Job", 42], ["Psalms", 150], ["Proverbs", 31],
  ["Ecclesiastes", 12], ["Song of Solomon", 8], ["Isaiah", 66], ["Jeremiah", 52], ["Lamentations", 5],
  ["Ezekiel", 48], ["Daniel", 12], ["Hosea", 14], ["Joel", 3], ["Amos", 9],
  ["Obadiah", 1], ["Jonah", 4], ["Micah", 7], ["Nahum", 3], ["Habakkuk", 3],
  ["Zephaniah", 3], ["Haggai", 2], ["Zechariah", 14], ["Malachi", 4],
];
const NT: Array<[string, number]> = [
  ["Matthew", 28], ["Mark", 16], ["Luke", 24], ["John", 21], ["Acts", 28],
  ["Romans", 16], ["1 Corinthians", 16], ["2 Corinthians", 13], ["Galatians", 6], ["Ephesians", 6],
  ["Philippians", 4], ["Colossians", 4], ["1 Thessalonians", 5], ["2 Thessalonians", 3], ["1 Timothy", 6],
  ["2 Timothy", 4], ["Titus", 3], ["Philemon", 1], ["Hebrews", 13], ["James", 5],
  ["1 Peter", 5], ["2 Peter", 3], ["1 John", 5], ["2 John", 1], ["3 John", 1],
  ["Jude", 1], ["Revelation", 22],
];

export const BOOKS: readonly Book[] = [
  ...OT.map(([name, chapters]) => ({ name, chapters, testament: "OT" as const })),
  ...NT.map(([name, chapters]) => ({ name, chapters, testament: "NT" as const })),
].map((b, i) => ({ ...b, id: i + 1, slug: b.name.toLowerCase().replaceAll(" ", "") }));

export const TOTAL_CHAPTERS = 1189;

const byId = new Map(BOOKS.map((b) => [b.id, b]));
const byName = new Map(BOOKS.map((b) => [b.name, b]));

export function bookById(id: number): Book {
  const b = byId.get(id);
  if (!b) throw new RangeError(`Unknown book id ${id}`);
  return b;
}

export function bookByName(name: string): Book {
  const b = byName.get(name);
  if (!b) throw new RangeError(`Unknown book "${name}"`);
  return b;
}
